import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ActionCommand, ActionCommandService } from '../../../../services/action-command.service';
import { MenuStateService } from '../../../../services/menu-state.service';
import { SangriaSuprimentoService } from '../../../../services/sangria-suprimento.service';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputTextModule } from 'primeng/inputtext';
import { TextareaModule } from 'primeng/textarea';
import { ButtonModule } from 'primeng/button';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-withdrawal',
  imports: [CommonModule, FormsModule, InputNumberModule, InputTextModule, TextareaModule, ButtonModule],
  templateUrl: './withdrawal.component.html'
})
export class WithdrawalComponent implements OnInit, OnDestroy, ActionCommand {

  withdrawalValue: number = 0;
  observations: string = '';
  specie: string = '';
  loading = false;

  constructor(
    @Inject(ActionCommandService) private actionCommandService: ActionCommandService,
    @Inject(MenuStateService) private menuStateService: MenuStateService,
    @Inject(MessageService) private messageService: MessageService,
    private sangriaSuprimentoService: SangriaSuprimentoService
  ) {}

  ngOnInit(): void {
    this.registerCommands();
  }

  ngOnDestroy(): void {
    this.unregisterCommands();
  }

  private registerCommands(): void {
    // Registrar comando F1 para realizar sangria
    this.actionCommandService.registerCommand({
      getKey: () => 'F1',
      execute: () => this.performWithdrawal(),
      getDescription: () => 'Realizar Sangria'
    });

    // Registrar comando ESC para voltar
    this.actionCommandService.registerCommand({
      getKey: () => 'ESC',
      execute: () => this.goBack(),
      getDescription: () => 'Voltar'
    });
  }

  private unregisterCommands(): void {
    this.actionCommandService.unregisterCommand('F1');
    this.actionCommandService.unregisterCommand('ESC');
  }

  performWithdrawal(): void {
    if (this.withdrawalValue <= 0) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Atenção!',
        detail: 'O valor da sangria deve ser maior que zero.',
        life: 3000
      });
      return;
    }

    const pdvId = localStorage.getItem('pdvId');
    if (!pdvId) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Atenção!',
        detail: 'Nenhum PDV/turno aberto. Abra o turno antes de realizar sangria.',
        life: 4000
      });
      return;
    }

    this.loading = true;
    this.sangriaSuprimentoService.createWithdrawal({
      amount: this.withdrawalValue,
      pdvId: parseInt(pdvId, 10),
      description: this.observations?.trim() || null,
      specie: this.specie?.trim() || null
    }).subscribe({
      next: () => {
        this.loading = false;
        this.messageService.add({
          severity: 'success',
          summary: 'Sucesso!',
          detail: `Sangria de ${this.withdrawalValue.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })} realizada com sucesso!`,
          life: 3000
        });
        this.withdrawalValue = 0;
        this.observations = '';
        this.specie = '';
      },
      error: (err) => {
        this.loading = false;
        const detail = err?.error?.message ?? err?.message ?? 'Não foi possível realizar a sangria. Tente novamente.';
        this.messageService.add({
          severity: 'error',
          summary: 'Erro!',
          detail,
          life: 5000
        });
      }
    });
  }

  goBack(): void {
    this.menuStateService.goBackToMainMenu();
  }

  // Implementação da interface ActionCommand
  getKey(): string {
    return 'F1';
  }

  execute(): void {
    this.performWithdrawal();
  }

  getDescription(): string {
    return 'Realizar Sangria';
  }
}
